import { FilterType } from '@/hooks/useLobbyUI';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CircleIcon from '@mui/icons-material/Circle';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GameType as GameTypeEnum } from '../../../../models/games/enums/GameType';
import './index.scss';

type GameTypeSelectorProp = {
    dropdown: number[];
    gameType: number;
    playButtonAudio: () => void;
    setGameType: Dispatch<SetStateAction<number>>;
};
export const GameTypeSelector = (props: GameTypeSelectorProp) => {
    const { gameType, setGameType, dropdown, playButtonAudio } = props;
    const id = 'game-type-menu';
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        playButtonAudio();
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleChangeType = (c: FilterType) => {
        let lgt = gameType;
        if (c === dropdown[0]) {
            lgt = dropdown[0];
        } else {
            if ((lgt & c) > 0) lgt = lgt ^ c;
            else {
                lgt = lgt | c;
            }
        }

        if (lgt === 0) return;

        setGameType(lgt);
        playButtonAudio();
    };
    useEffect(() => {
        setGameType(dropdown[0]);
    }, [dropdown]);

    return (
        <Grid item className="game-type-selector">
            <Button
                aria-controls={open ? id : undefined}
                aria-haspopup={true}
                aria-expanded={open ? true : undefined}
                variant="contained"
                disableElevation
                onClick={handleOpen}
                endIcon={open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                className={
                    open ? 'game-type-button-selected' : 'game-type-button'
                }
            >
                {gameType === dropdown[0] ? (
                    <Typography className="game-type-button-text">
                        {t(getString(-1))}
                    </Typography>
                ) : (
                    <Typography className="game-type-button-text">
                        {t('betlog.selectedGame')}
                    </Typography>
                )}
            </Button>
            <Menu
                id={id}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                sx={{
                    '& .MuiMenu-paper': {
                        marginTop: '0.25rem',
                        borderRadius: '2px',
                        background:
                            'linear-gradient(95deg, rgba(33, 28, 28, 0.80) 0%, rgba(77, 71, 64, 0.64) 100%)',
                        boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.35)',
                        backdropFilter: 'blur(13.333333969116211px)',
                        width: anchorEl
                            ? (anchorEl as HTMLElement).offsetWidth
                            : 'auto',
                    },
                }}
            >
                {dropdown.map((c, i) => (
                    <MenuItem
                        onClick={() => handleChangeType(c)}
                        value={c}
                        key={`game-type-selector-${c}`}
                    >
                        <Checkbox
                            sx={{ paddingLeft: 0 }}
                            icon={
                                <CircleIcon
                                    style={{
                                        borderRadius: '16.667px',
                                        border: '1px solid rgba(255, 255, 255, 0.30)',
                                        color: 'rgba(255, 255, 255, 0.10)',
                                        boxShadow:
                                            '3.333px 1.333px 3.333px 0px rgba(0, 0, 0, 0.15)',
                                    }}
                                />
                            }
                            checkedIcon={<CheckCircleOutlineIcon />}
                            checked={(gameType & c) === c}
                        />
                        <ListItemText
                            sx={{ textWrap: 'wrap' }}
                            primary={t(getString(i === 0 ? -1 : c))}
                        />
                    </MenuItem>
                ))}
            </Menu>
        </Grid>
    );
};

const getString = (c: GameTypeEnum | -1) => `betlog.gameCode.${c}`;
